<template>
  <div class="mt-3">
    <v-container
      v-if="$vuetify.breakpoint.mdAndUp"
      style="padding: 0;"
      fluid
    >
      <Banner
        id="main-content"
        heading="Community- Viva Engage"
        subtitle="Join the conversation on Yammer or a Statewide staffroom"
        icon="storefront"
        :icon-size="bannerIconSize"
        tabindex="-1"
      />
    </v-container>

    <v-container
      fluid
      class="mt-3"
    >
      <iframe name="embed-feed" title="Viva Engage" src="https://engage.cloud.microsoft/embed/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIzMjU2MDU1Mzk4NCJ9?header=false&footer=false&theme=light&includeFeedInformation=false" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 1200px;"></iframe>
    </v-container>
  </div>
</template>

<script>
import {Banner} from '@nswdoe/doe-ui-core';

export default {

  components: {
    Banner,
  },
  data() {
    return {
      bannerIconSize: '3.5rem',
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';

.v-container{
  height: 100vh;
  overflow: hidden;
}
</style>
